import { useState, useEffect, useCallback } from "react";
import { Table, Spinner, Form, Container, Row, Col, Button } from "react-bootstrap";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { FaSyncAlt } from "react-icons/fa";

const InnovationsTwo = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [abhiyanList, setAbhiyanList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [talukaList, setTalukaList] = useState([]);

  const [selectedAbhiyan, setSelectedAbhiyan] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [selectedTaluka, setSelectedTaluka] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);

  // ⭐ NEW: Report Filter
  const [selectedFilter, setSelectedFilter] = useState('InnovationsTwo');


  const apiBaseUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  /* -----------------------------------------------
      ⭐ HANDLE REPORT CHANGE
  ------------------------------------------------ */
  const handleFilterChange = (event) => {
  const selected = event.target.value;
  setSelectedFilter(selected);

  if (selected === 'Innovations') navigate('/innovations');
  if (selected === 'InnovationOne') navigate('/innovationsOne');
  if (selected === 'Innovationtwo') navigate('/innovationsTwo');
};

  /* ================= CHECKBOX DROPDOWN ================= */
  const CheckboxDropdown = ({
    label,
    options,
    idKey,
    nameKey,
    selected,
    setSelected,
    disabled,
    dropdownKey,
  }) => {
    const toggle = () => {
      if (!disabled)
        setOpenDropdown(openDropdown === dropdownKey ? null : dropdownKey);
    };

    return (
      <Form.Group className="mb-3 position-relative">
        <Form.Label>{label}</Form.Label>

        <div
          className={`form-select ${disabled ? "disabled" : ""}`}
          style={{ cursor: disabled ? "not-allowed" : "pointer" }}
          onClick={toggle}
        >
          {selected.length === options.length && options.length > 0
            ? "All Selected"
            : selected.length > 0
            ? `${selected.length} Selected`
            : "All"}
        </div>

        {openDropdown === dropdownKey && !disabled && (
          <div
            className="position-absolute bg-white border rounded shadow-sm w-100"
            style={{ zIndex: 9999, maxHeight: 220, overflowY: "auto", bottom: "100%", marginBottom: "8px", top: "auto" }}
          >
            <div className="px-3 py-2 border-bottom fw-bold">
              <Form.Check
                type="checkbox"
                label="Select All"
                checked={selected.length === options.length}
                onChange={(e) =>
                  setSelected(e.target.checked ? options.map(o => o[idKey]) : [])
                }
              />
            </div>

            {options.map(o => (
              <div key={o[idKey]} className="px-3 py-2">
                <Form.Check
                  type="checkbox"
                  label={o[nameKey]}
                  checked={selected.includes(o[idKey])}
                  onChange={() =>
                    setSelected(
                      selected.includes(o[idKey])
                        ? selected.filter(x => x !== o[idKey])
                        : [...selected, o[idKey]]
                    )
                  }
                />
              </div>
            ))}
          </div>
        )}
      </Form.Group>
    );
  };


  /* -----------------------------------------------------------
      📌 0️⃣ Calculate Totals Function
  ----------------------------------------------------------- */
  const calculateTotals = (items) => {
    let totals = {
      totalbahumajaliimarati: 0,
      bahumajliImarti: 0,
      totalgrusankul: 0,
      gruhsankule: 0,
      totalbahumajaliGruhsankul: 0,
      bahumajliGruhsankule: 0,
    };

    items.forEach((item) => {
      totals.bahumajliImarti += parseInt(item.tbl_valula_paryay || 0);
      totals.totalbahumajaliimarati += parseInt(item.tbl_aadarsh_gharkul || 0);

      totals.gruhsankule += parseInt(item.tbl_new_build_technology || 0);
      totals.totalgrusankul += parseInt(item.tbl_precast || 0);

      totals.bahumajliGruhsankule += parseInt(item.tbl_logo || 0);
      totals.totalbahumajaliGruhsankul += parseInt(item.tbl_gruhkarj || 0);
    });

    return totals;
  };

  /* -----------------------------------------------------------
     1️⃣ LOAD ABHIYANS
  ----------------------------------------------------------- */
  const fetchAbhiyans = useCallback(async () => {
    try {
      const res = await fetch(`${apiBaseUrl}/innovation/abhiyans`);
      const json = await res.json();
      setAbhiyanList(json);
    } catch (err) {
      console.error("Error fetching Abhiyans:", err);
    }
  }, [apiBaseUrl]);

  /* -----------------------------------------------------------
     2️⃣ LOAD DEFAULT DISTRICT VIEW
  ----------------------------------------------------------- */
  const fetchAllDistricts = useCallback(async () => {
    setLoading(true);
    try {
    const res = await fetch(`${apiBaseUrl}/innovation/districts`);
      const json = await res.json();
      setData(json);
      setDistrictList(json);
    } catch (err) {
      console.error("Error fetching districts:", err);
    } finally {
      setLoading(false);
    }
  }, [apiBaseUrl]);

  /* -----------------------------------------------------------
     3️⃣ WHEN ABHIYAN SELECTED → GET DISTRICTS
  ----------------------------------------------------------- */
  const fetchDistrictsByAbhiyan = useCallback(async (abhiyanIds) => {
    if (!abhiyanIds || abhiyanIds.length === 0) return;
    setLoading(true);
    try {
      const res = await fetch(`${apiBaseUrl}/innovation/abhiyans/${abhiyanIds.join(",")}/districts`);
      const json = await res.json();

      setData(json);
      setDistrictList(json);
      setTalukaList([]);
      setSelectedDistrict([]);
      setSelectedTaluka([]);
    } catch (err) {
      console.error("Error fetching districts by Abhiyan:", err);
    } finally {
      setLoading(false);
    }
  }, [apiBaseUrl]);

  /* -----------------------------------------------------------
     4️⃣ WHEN DISTRICT SELECTED → GET TALUKAS
  ----------------------------------------------------------- */
  const fetchTalukasByDistrict = useCallback(
    async (abhiyanIds, districtIds) => {
      if (!abhiyanIds || abhiyanIds.length === 0 || !districtIds || districtIds.length === 0) return;
      setLoading(true);

      try {
        const res = await fetch(
          `${apiBaseUrl}/innovation/abhiyans/${abhiyanIds.join(",")}/districts/${districtIds.join(",")}/talukas`
        );
        const json = await res.json();

        setTalukaList(json);
        setData(json);
        setSelectedTaluka([]);
      } catch (err) {
        console.error("Error fetching talukas:", err);
      } finally {
        setLoading(false);
      }
    },
    [apiBaseUrl]
  );

  /* -----------------------------------------------------------
     5️⃣ WHEN TALUKA SELECTED → FILTER ONLY THAT TALUKA
  ----------------------------------------------------------- */
  useEffect(() => {
  if (selectedTaluka.length > 0 && talukaList.length > 0) {
    const filtered = talukaList.filter((t) =>
      selectedTaluka.includes(t.taluka_id)
    );
    setData(filtered);
  }
}, [selectedTaluka, talukaList]);

  /* -----------------------------------------------------------
     6️⃣ REFRESH ALL
  ----------------------------------------------------------- */
  const handleRefresh = () => {
    setSelectedAbhiyan([]);
    setSelectedDistrict([]);
    setSelectedTaluka([]);
    setDistrictList([]);
    setTalukaList([]);
    fetchAllDistricts();
  };

  /* -----------------------------------------------------------
     7️⃣ EXPORT EXCEL
  ----------------------------------------------------------- */
  const exportToExcel = () => {
  
    // 🔥 Decide correct column heading dynamically
    const areaColumnName = selectedDistrict.length > 0 ? "तालुका" : "जिल्हा";
  
    // Prepare clean export format
    const exportData = filteredView.map((item, index) => ({
      "अ. क्र": index + 1,
  
      // 🔥 Dynamic column (जिल्हा / तालुका)
      [areaColumnName]: selectedDistrict.length > 0 ? item.taluka : item.district,
  
      "वाळूला पर्याय म्हणुन वापरलेली संख्या": item.tbl_valula_paryay || "0",
      "आदर्श घरकुले संख्या": item.tbl_aadarsh_gharkul || "0",
  
      "नविन बांधकाम तंत्रज्ञान वापरून संख्या": item.tbl_new_build_technology || "0",
      "प्रीकास्ट टेक्नॉलॉजी": item.tbl_precast || "0",
  
      "घरावर लोगो असलेल्यांची संख्या": item.tbl_logo || "0",
      "गृहकर्ज झालेल्या लाभार्थ्यांची संख्या": item.tbl_gruhkarj || "0",
    }));
  
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "इतर नाविन्यपूर्ण उपक्रम");
    XLSX.writeFile(wb, "इतर नाविन्यपूर्ण उपक्रम.xlsx");
  };

  /* -----------------------------------------------------------
     LOAD INITIAL DATA
  ----------------------------------------------------------- */
  useEffect(() => {
    fetchAbhiyans();
    fetchAllDistricts();
  }, [fetchAbhiyans, fetchAllDistricts]);

  /* -----------------------------------------------------------
     TRIGGER FETCH WHEN FILTERS CHANGE
  ----------------------------------------------------------- */
  useEffect(() => {
    if (selectedAbhiyan.length > 0) fetchDistrictsByAbhiyan(selectedAbhiyan);
  }, [selectedAbhiyan, fetchDistrictsByAbhiyan]);

  useEffect(() => {
    if (selectedDistrict.length > 0 && selectedAbhiyan.length > 0)
      fetchTalukasByDistrict(selectedAbhiyan, selectedDistrict);
  }, [selectedDistrict, selectedAbhiyan, fetchTalukasByDistrict]);

  /* -----------------------------------------------------------
     SEARCH FILTER
  ----------------------------------------------------------- */
  const filteredView = data.filter((item) =>
    Object.values(item).join(" ").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totals = calculateTotals(filteredView);

  return (
    <Container fluid>
      <Row>
        {/* LEFT FILTER PANEL */}
        <Col md={2} className="p-4">
          <Button variant="secondary" onClick={() => navigate("/")} className="mb-3 w-100">
            Back
          </Button>

          <div className="p-3 shadow-sm rounded mt-3" style={{ backgroundColor: "#EAF0F9" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h5 className="fw-bold" style={{ color: "#1F3C88" }}>Filters</h5>
              <div
                onClick={handleRefresh}
                style={{
                  backgroundColor: "#EAF2FF",
                  borderRadius: "50%",
                  padding: "6px",
                  cursor: "pointer",
                }}
              >
                <FaSyncAlt size={16} style={{ color: "#1F3C88" }} />
              </div>
            </div>

            {/* 🔵 Select Report */}
            <Form.Group className="mb-3">
              <Form.Label>Select Report</Form.Label>
              <Form.Select value={selectedFilter} onChange={handleFilterChange}>
                <option value="Innovations">भूमिहीन लाभार्थ्यांना जागा उपलब्ध करून देण्यासाठीचे नाविन्यपूर्ण उपक्रम</option>
                <option value="InnovationOne">घरकुले वेळेत पूर्ण होण्यासाठीचे नाविन्यपूर्ण उपक्रम</option>
                <option value="Innovationtwo">इतर नाविन्यपूर्ण उपक्रम</option>
              </Form.Select>
            </Form.Group>

            <CheckboxDropdown 
              label="अभियान" 
              options={abhiyanList}
              idKey="abhiyan_id" 
              nameKey="abhiyan_name"
              selected={selectedAbhiyan} 
              setSelected={setSelectedAbhiyan} 
              dropdownKey="abhiyan" 
            />

            <CheckboxDropdown 
              label="जिल्हा" 
              options={districtList}
              idKey="district_id" 
              nameKey="district"
              selected={selectedDistrict} 
              setSelected={setSelectedDistrict}
              disabled={!districtList.length} 
              dropdownKey="district" 
            />

            <CheckboxDropdown 
              label="तालुका" 
              options={talukaList}
              idKey="taluka_id" 
              nameKey="taluka"
              selected={selectedTaluka} 
              setSelected={setSelectedTaluka}
              disabled={!talukaList.length} 
              dropdownKey="taluka" 
            />
          </div>
        </Col>

        {/* MAIN TABLE */}
        <Col md={10} className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
            <h5 className="fw-bold mb-0" style={{ color: "#1F3C88" }}>
              इतर नाविन्यपूर्ण उपक्रम
            </h5>

            <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
              <Form.Group controlId="searchBox" style={{ width: '250px' }}>
                <Form.Control
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    borderRadius: '6px',
                    height: '38px',
                    fontSize: '14px',
                    border: '1px solid #ced4da',
                  }}
                />
              </Form.Group>

              <Button
                style={{
                  backgroundColor: "#4da6ff",
                  borderColor: "#4da6ff",
                }}
                onClick={exportToExcel}
              >
                Export to Excel
              </Button>
            </div>
          </div>

          {loading ? (
            <Spinner animation="border" className="d-block mx-auto" />
          ) : (
            <div style={{ maxHeight: "500px", overflowY: "auto" }}>
              <Table striped bordered hover responsive>
                <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa" }}>
                  <tr>
                    <th className="th-class-ac">अ. क्र</th>
                    {selectedDistrict.length === 0 ? <th>जिल्हा</th> : <th>तालुका</th>}
                    <th>वाळूला पर्याय म्हणुन वापरलेली संख्या</th>
                    <th>आदर्श घरकुले संख्या</th>
                    <th>नविन बांधकाम तंत्रज्ञान वापरून संख्या</th>
                    <th>प्रीकास्ट टेक्नॉलॉजी</th>
                    <th>घरावर लोगो असलेल्यांची संख्या</th>
                    <th>गृहकर्ज झालेल्या लाभार्थ्यांची संख्या</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredView.length > 0 ? (
                    filteredView.map((item, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        {selectedDistrict.length === 0 && <td>{item.district}</td>}
                        {selectedDistrict.length > 0 && <td>{item.taluka}</td>}

                        <td>{item.tbl_valula_paryay || "0"}</td>
                        <td>{item.tbl_aadarsh_gharkul || "0"}</td>

                        <td>{item.tbl_new_build_technology || "0"}</td>
                        <td>{item.tbl_precast || "0"}</td>

                        <td>{item.tbl_logo || "0"}</td>
                        <td>{item.tbl_gruhkarj || "0"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No Records Found
                      </td>
                    </tr>
                  )}

                  {/* ⭐ TOTAL ROW */}
                  <tr style={{ backgroundColor: "#eef3ff", fontWeight: "bold" }}>
                    <td colSpan={2} style={{ textAlign: "center" }}>Total</td>
                    <td>{totals.bahumajliImarti}</td>
                    <td>{totals.totalbahumajaliimarati}</td>
                    <td>{totals.gruhsankule}</td>
                    <td>{totals.totalgrusankul}</td>
                    <td>{totals.bahumajliGruhsankule}</td>
                    <td>{totals.totalbahumajaliGruhsankul}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default InnovationsTwo;
